module.exports = __webpack_public_path__ + "media/warning.eda058a7.wav";